package com.parmartechnologies.ui.media

import androidx.compose.runtime.Composable
import com.parmartechnologies.core.feature.mediaFile.model.MediaFile
import com.parmartechnologies.ui.core.mediaFile.viewModel.MediaFileViewModel

@Composable
actual fun MediaFilePickerView(
    id: String?,
    businessId: String?,
    mediaFile: MediaFile?,
    isEditable: Boolean,
    viewModel: MediaFileViewModel
) {

}